module.exports = __webpack_public_path__ + "static/media/chat_left.5f6a51d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/comic_theme/chat_left.svg
// module id = 443
// module chunks = 0